module.exports = __webpack_public_path__ + "assets/95432a59ed56f33cf995754227759af7.mp3";